import oRequest from '@/libsV2/request.js';

const URL = {
    // //竣工评价
    // GET_LIST: 'discuss.index/completed_list', //竣工评价展示
    // DISCUSS_ADD: 'discuss.index/discuss_add',// 评论添加
    // GET_PIC: "ssp/adment/info",//获取图片
    // RESUBMIT: "discuss.index/discuss_to", //添加追加评价
    // //评价展示
    // GETEVALUETE: "discuss.index/completed_list",
    // OSSCONFIG: "discuss.ossconfig/getConfig", //oss
    // TAGLIST: "discuss.index/tag_list" //五星标签

    //竣工评价 v2
    GET_LIST: 'discuss.indexv2/completed_list', //竣工评价展示
    GET_PROJECT_TYPE: 'discuss.indexv2/getprojecttype', //判断是否是五恒案例
    DISCUSS_ADD: 'discuss.indexv2/discuss_add',// 评论添加
    GET_PIC: "ssp/adment/info",//获取图片
    // RESUBMIT: "discuss.indexv2/discuss_to", //添加追加评价
    RESUBMIT: "discuss.indexv2/discuss_add", //添加追加评价
    //评价展示
    GETEVALUETE: "discuss.indexv2/completed_list",
    OSSCONFIG: "discuss.ossconfig/getConfig", //oss
    TAGLIST: "discuss.indexv2/tag_list", //五星标签
    DELETE: "discuss/indexv2/delDis",

    //用户卷宗
    JZGETEVALUETE: "archives/discussv2/completed_list",
    JZTAGLIST: "archives/discussv2/tag_list", //五星标签,

}
//交付评价星级对应标签
export default {
    projectType(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.GET_PROJECT_TYPE, oData)
    },
    jzCopList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JZGETEVALUETE, oData)
    },
    jzTagList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JZTAGLIST, oData)
    },
    discussAdd(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DISCUSS_ADD, oData)
    },
    getList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.GET_LIST, oData)
    },
    getTopPic(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.GET_PIC, oData)
    },
    reSubmit(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.RESUBMIT, oData)
    },
    getEvaluete(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.GETEVALUETE, oData)
    },
    ossconfig(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.OSSCONFIG, oData)
    },
    tagList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.TAGLIST, oData)
    },
    delete(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DELETE, oData)
    },
}

